import { getInitialStateFromConfig } from "helpers/form";

const config = {
    oldPassword: {
        // field
        label: "Старый пароль",
        inputProps: { name: "oldPassword", type: "password" },
    },
    newPassword: {
        // field
        label: "Новый пароль",
        inputProps: { name: "newPassword", type: "password" },
    },
    newPasswordRepeat: {
        // field
        label: "Повторите пароль",
        inputProps: { name: "newPasswordRepeat", type: "password" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
